import { SvgIcon, Link } from "@material-ui/core";
//import { ReactComponent as GitHub } from "../../assets/icons/github.svg";
import { ReactComponent as Medium } from "../../assets/icons/medium.svg";
import { ReactComponent as Twitter } from "../../assets/icons/twitter.svg";
import { ReactComponent as Discord } from "../../assets/icons/discord.svg";

export default function Social() {
  return (
    <div className="social-row">
      <Link href="https://discord.gg/x6WPuK5P8p" target="_blank">
        <SvgIcon color="primary" component={Discord} />
      </Link>
      <Link href="https://twitter.com/GWS_Finance" target="_blank">
        <SvgIcon color="primary" component={Twitter} />
      </Link>
      {/* <Link href="ps://www.linkedin.com/company/generational-wealth-society/" target="_blank">
        <i class="fa-brands fa-linkedin-in"></i>
      </Link> */}
      <Link href="https://gwsfinance.medium.com/" target="_blank">
        <i class="fa-brands fa-medium"></i>
      </Link>
    </div>
  );
}
